import React, { useState, useEffect } from "react"
import { Card, CardBody, Alert } from "reactstrap"
import CustomHeaderTitle from "components/Common/CustomHeaderTitle"
import RoleBasedPermissionSelector from "components/Role/RoleBasedPermissionSelector"

const UserDirectPermissions = ({
  groupedPermissions,
  userDirectPermissions,
  onChangePermission,
  permissionResponse,
  activePermissions,
  roleName,
}) => {
  const [selectedPermissions, setSelectedPermissions] = useState(
    userDirectPermissions || []
  )

  useEffect(() => {
    if (userDirectPermissions) {
      setSelectedPermissions(userDirectPermissions)
    }
  }, [userDirectPermissions])

  // Handle permission change from the GroupedPermissionSelector
  const handlePermissionChange = newPermissions => {
    const added = newPermissions.filter(p => !selectedPermissions.includes(p))
    const removed = selectedPermissions.filter(p => !newPermissions.includes(p))

    // Process added permissions
    added.forEach(permission => {
      onChangePermission({ value: permission }, "add")
    })

    // Process removed permissions
    removed.forEach(permission => {
      onChangePermission({ value: permission }, "delete")
    })

    setSelectedPermissions(newPermissions)
  }

  return (
    <Card>
      <CardBody>
        <CustomHeaderTitle
          loading={permissionResponse?.loading}
          title={"Direct User Permissions"}
          lgColumn={4}
          rowCount={false}
          orderingList={false}
          searchBox={false}
          rightBtn={false}
        />

        <div className="mt-4">
          <h5 className="mb-3">
            <i className="bx bx-key me-2"></i>
            Direct User Permissions
          </h5>
          <p className="text-muted mb-4">
            Manage this user's direct permissions. These permissions are granted
            or revoked directly to this user, independent of their role
            permissions.
          </p>

          <RoleBasedPermissionSelector
            groupedPermissions={groupedPermissions}
            selectedPermissions={selectedPermissions}
            onChange={handlePermissionChange}
            disabledPermissions={[]}
          />
        </div>
      </CardBody>
    </Card>
  )
}

export default UserDirectPermissions
